const message = 'Wpisz poprawny przebieg'
export default {
    required: 'Pole przebieg jest wymagane',
    min: {
        value: 0,
        message,
    },
    max: {
        value: 999999,
        message,
    }
}